<app-file-drop [externalErrors]="errors" [allowedTypes]="['.pdf']" (filesSelected)="onFileChange($event)">
</app-file-drop>
<input name="fileUploaded" required type="hidden" [(ngModel)]="hasFile" />
